import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './fonts/EncodeSans-VariableFont_wdth,wght.ttf';

ReactDOM.render(<App />,document.getElementById('root'));